import React from 'react';
import Text from 'components/Text';
import formatRankForDisplay from 'utils/ui/formatRankForDisplay';
export function Ranking(_ref) {
  var rank = _ref.rank;
  if (!rank) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    mr: ['xxxs', 'xxs'],
    breakpoints: "xs",
    dimmed: true
  }, formatRankForDisplay(rank)), ' ');
}
export default Ranking;